import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import NDAService from './NDAservice';
const initialState = [];

export const getNDADocuments = createAsyncThunk('NDA_LIST', async () => {
    const res = await NDAService.get();
    return res.data;
});

export const deleteNDADocuments = createAsyncThunk('NDA_LIST', async (ids) => {
    const res = await NDAService.deleteDocument(ids);
    return res.data;
});

